import {
  $InternalStudentCoursesState,
  $InternalStudentCourses,
  $InternalStudentCourseState,
  resetInternalStudentCourse,
  fetchInternalStudentCourses,
} from "@store/internal-study/students-store";
import { setTitle } from "@store/title-store";
import { ErrorIndicator, Loader } from "@ui/indicators";
import Courses from "@components/students/courses";
import clsx from "clsx";
import style from "@scss/pages/home.module.scss";
import { useEffect } from "react";
import { useUnit } from "effector-react";

const Home = () => {
  const { isLoading, error, isFetched } = useUnit($InternalStudentCoursesState);
  const courseState = useUnit($InternalStudentCourseState);
  const courses = useUnit($InternalStudentCourses);

  useEffect(() => {
    if (!isFetched) {
      fetchInternalStudentCourses();
      setTitle([{ title: "Курсы", href: "/" }]);
    }
    if (courseState.isFetched) {
      resetInternalStudentCourse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="content-container">
      <div className="content-section">
        <div className={clsx(style.home_content)}>
          <div className={clsx(style.top_blocks)}>
            <div className={clsx(style.calendar_block, "bg-white", "w-100")}>
              {isLoading ? (
                <Loader />
              ) : error ? (
                <ErrorIndicator />
              ) : (
                <Courses items={courses} />
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
